"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiVersion = void 0;
var ApiVersion = exports.ApiVersion = 3;